export default __webpack_public_path__ + "static/media/pay-per-view-ads.e71f9579.jpg";